import { render, staticRenderFns } from "./InvoiceDetailsToBeIssued.vue?vue&type=template&id=060bc6d0&scoped=true&"
import script from "./InvoiceDetailsToBeIssued.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsToBeIssued.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsToBeIssued.vue?vue&type=style&index=0&id=060bc6d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060bc6d0",
  null
  
)

export default component.exports